export default __webpack_public_path__ + "static/media/roboto-condensed-v19-latin-italic.53545bf0.woff2";